const COLUMN_DEFINITIONS = [
  { key: 'num', label: 'ลำดับที่' },
  { key: 'code', label: 'รหัสพนักงาน' },
  { key: 'level', label: 'Level' },
  { key: 'name', label: 'ชื่อ-นามสกุล' },
  { key: 'position', label: 'ตำแหน่ง' },
  { key: 'division', label: 'สายงาน' },
  { key: 'faction', label: 'ฝ่าย' },
  { key: 'department', label: 'แผนก' },
  {
    key: 'type',
    label: 'ประเภทพนักงาน (รายวัน/รายเดือน, Temporary/Permanent)'
  },
  { key: 'travelling', label: 'ค่าเดินทาง' },
  { key: 'phone_packet', label: 'ค่าโทรศัพท์' },
  { key: 'start_date', label: 'วันที่เริ่มงาน' },
  { key: 'id_card', label: 'เลขที่บัตรประชาชน/เลข Passport' },
  { key: 'account_no', label: 'เลขที่บัญชีธนาคาร SCB' },
  { key: 'email', label: 'E-mail ส่วนตัว' },
  { key: 'others', label: 'หมายเหตุ' }
]

const borderStyle = {
  borderColor: '#000000',
  borderStyle: 'thin'
}

const headerStyle = {
  ...borderStyle,
  align: 'center',
  alignVertical: 'center',
  backgroundColor: '#9CDCEA',
  fontWeight: 'bold',
  wrap: true
}

const highlightedHeaderStyle = {
  ...headerStyle,
  backgroundColor: '#CA2525',
  textColor: '#FFFFFF'
}

function createTitleRow(value) {
  return [
    {
      value: String(value ?? ''),
      columnSpan: COLUMN_DEFINITIONS.length,
      fontSize: 16,
      fontWeight: 'bold'
    },
    ...Array(COLUMN_DEFINITIONS.length - 1).fill(null)
  ]
}

export function buildNewEmployeeReportSheet({
  data = [],
  organization,
  periodLabel
}) {
  const sheetData = [
    createTitleRow(organization),
    createTitleRow(`พนักงานเข้าใหม่ เดือน${periodLabel || '-'}`),
    Array(COLUMN_DEFINITIONS.length).fill(null),
    COLUMN_DEFINITIONS.map((column, index) => ({
      value: column.label,
      ...(index === 10 || index === 11
        ? highlightedHeaderStyle
        : headerStyle)
    })),
    ...data.map((row) =>
      COLUMN_DEFINITIONS.map((column) => ({
        value: row[column.key] ?? ''
      }))
    )
  ]

  return {
    sheetData,
    sheetOptions: {
      sheet: 'New Employee'
    }
  }
}
